var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg360(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2752 24.5724L12.5928 20.8902L16.2752 17.208L17.0992 18.032L14.2407 20.8902L17.0992 23.7485L16.2752 24.5724Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21.6772H13.4166V20.0713H14C21.5614 20.0713 26.8334 17.1108 26.8334 14.4514C26.8334 11.7917 21.5614 8.83122 14 8.83122C6.4386 8.83122 1.1666 11.7917 1.1666 14.4514C1.1666 16.6392 4.85629 19.3186 11.0251 20.0113L10.9302 21.6169C5.49054 21.0048 0 18.5559 0 14.4514C0 9.75444 7.21149 7.22559 14 7.22559C20.7885 7.22559 28 9.75444 28 14.4514C28 19.148 20.7885 21.6772 14 21.6772Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg360);
export default __webpack_public_path__ + "static/media/360.b15ef84acb11d26f4239aec509d552a6.svg";
export { ForwardRef as ReactComponent };